/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import moment from 'moment';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Popover } from 'web-ui-components/lib/atoms/popovers';
import withDescription from '../../../../containers/withDescription';
import withValidation from '../../../../containers/withValidation';
import DateField from '../../../../sharedComponents/DateField/DateField';
import { dateFormatFocus, dateFormat, dateFormatToday } from '../../../../config/';
import { getNextAvailableDate } from '../../../../states/calendar/selectors';

export const isDateToday = (date, todaysDate) => {
	if (moment.isMoment(date)) return date.isSame(todaysDate, 'day');
	return false;
};

export const getMinDate = ({ isManagePaymentEdit, isAuthorisationEdit, nextAvailableDate, todaysDate, type }) => {
	if (isAuthorisationEdit && nextAvailableDate && todaysDate.isBefore(nextAvailableDate)) {
		return nextAvailableDate;
	}
	return isManagePaymentEdit || type === 'repeating' ? moment(todaysDate).add(1, 'day') : todaysDate;
};

const mapState = (state) => ({
	nextAvailableDate: getNextAvailableDate(state),
});

/**
 * Fix: [QR-743](https://wearevm.atlassian.net/browse/QR-743)
 * This is a hack around the global app.css styles from web-ui-components,
 * which appear to include manual sizing tweaks that are no longer relevant.
 * Payments lacks the "F" structure seen in newer areas of iB as a result of
 * the rebrand, so several form elements share a line with eachother, which can
 * result in overcrowding.
 * To fight this, years ago, the original authors had to add manual media query
 * width rules to get the width right, accounting for styling issues specific
 * to the old version of react-datepicker used at the time. We have now, however
 * upgraded to the same version of react-datepicker as web-ui-components itself,
 * bringing better performance and compatibility.
 * However, if the legacy rules are left in, the text input displaying the
 * date can be cut off early on viewports larger than 1280px, leaving a
 * gap between the calendar icon button.
 *
 * As of web-ui-components 27.12.0 this isn't fixed (we weren't aware) and
 * we can't assume the host app is using the latest web-ui-components version
 * anyway, so we'll override it with an !important rule.
 *
 * @todo Good: Consider removing lines 80-90 `component.organsim.list-payment.scss`
 * from in web-ui-components.
 * @todo Better: Use a DatePicker component from Web-UI-Components that doesn't
 * depend on legacy SCSS.
 */
// Formerly width: calc(100% - 48px);
const overrideLegacyDatePickerStyles = `
	@media (min-width: 1280px) {
		.c-o-list-payment .c-o-list-payment__row .react-datepicker__input-container {
			width: 100% !important;
		}
	}
`;

class PaymentDate extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showDateDisabledMsg: false,
			date: this.props.date,
			dateFormat: isDateToday(this.props.date, this.props.todaysDate) ? dateFormatToday : dateFormat,
		};

		this.toggleDateMsg = this.toggleDateMsg.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.date !== this.state.date) {
			this.setState({
				date: nextProps.date,
				dateFormat: isDateToday(nextProps.date, nextProps.todaysDate) ? dateFormatToday : dateFormat,
			});
		}
	}

	toggleDateMsg() {
		const { isDateDisabled } = this.props;
		this.setState({ showDateDisabledMsg: isDateDisabled });
	}

	handleBlur() {
		const { date } = this.state;
		const newDate = date || moment();
		const newDateFormat = isDateToday(newDate, this.props.todaysDate) ? dateFormatToday : dateFormat;

		this.setState({ date: newDate, dateFormat: newDateFormat });
		this.props.onBlur();
	}

	handleChange(date) {
		this.setState({ date });
		this.props.handleDateChange(date);
	}

	handleFocus() {
		this.setState({ dateFormat: dateFormatFocus });
		this.props.onFocus();
	}

	render() {
		const {
			id,
			isToBiller,
			content,
			inputWrapClassName,
			copyDateToAll,
			isAuthorisationEdit,
			maxDate,
			paymentDates,
			isDateDisabled = false,
			showPopover = true,
		} = this.props;
		const { showDateDisabledMsg, date, dateFormat } = this.state;

		const minDate = getMinDate(this.props);

		return (
			<div className={inputWrapClassName}>
				<style>{overrideLegacyDatePickerStyles}</style>
				<DateField
					id={`field-date-${id}`}
					dateFormat={dateFormat}
					minDate={minDate}
					maxDate={maxDate}
					className="c-o-list-payment__input-with-fix"
					selectedDate={date && moment(date)}
					disabled={isDateDisabled}
					onClick={this.toggleDateMsg}
					onFocus={this.handleFocus}
					onBlur={this.handleBlur}
					onChange={this.handleChange}
					includeDates={paymentDates}
				/>
				{copyDateToAll && (
					<div className="c-o-list-payment__input-wrap-text-link">
						<Button
							onClick={() => copyDateToAll(this.state.date)}
							id="copy-date-to-all-button"
							size="xs"
							disabled={isAuthorisationEdit || !this.state.date}
						>
							{content.copyToAllButton}
						</Button>
					</div>
				)}
				{showPopover && (
					<Popover
						placement="bottom"
						isOpen={isDateDisabled && showDateDisabledMsg}
						isButtonRequired={false}
						content={isToBiller ? content.billerDateMsg : content.accountDateMsg}
						onClick={() => this.setState({ showDateDisabledMsg: false })}
					/>
				)}
			</div>
		);
	}
}
PaymentDate.defaultProps = {
	todaysDate: moment(),
	maxDate: moment(moment()).add(1, 'year'),
	onFocus: () => {},
	onBlur: () => {},
	isDateDisabled: false,
};

PaymentDate.propTypes = {
	id: PropTypes.string.isRequired,
	handleDateChange: PropTypes.func.isRequired,
	date: PropTypes.shape({}).isRequired,
	isToBiller: PropTypes.bool,
	isDateDisabled: PropTypes.bool,
	onFocus: PropTypes.func,
	onBlur: PropTypes.func,
	todaysDate: PropTypes.shape({}),
	inputWrapClassName: PropTypes.string,
	content: PropTypes.shape({
		billerDateMsg: PropTypes.string.isRequired,
		accountDateMsg: PropTypes.string.isRequired,
		copyToAllButton: PropTypes.string.isRequired,
	}),
	copyDateToAll: PropTypes.func,
	isAuthorisationEdit: PropTypes.bool,
	nextAvailableDate: PropTypes.shape({}),
	maxDate: PropTypes.shape({}),
	paymentDates: PropTypes.arrayOf(PropTypes.instanceOf(moment)),
	showPopover: PropTypes.bool,
};
export { PaymentDate };

const validation = withValidation({
	validations: ['date', 'minDate'],
	key: 'date',
	message: 'Select the date you want to move this money.',
});

export default compose(connect(mapState), validation, withDescription)(PaymentDate);
